<script lang="ts">
    import { _ } from "svelte-i18n"
    import Index from "../SEO/Index.svelte"
    export let params
    let orderSequence, postalCode
    if (params) {
        orderSequence = params.split("/")[0]
        postalCode = params.split("/")[1]
    }
</script>

<Index noIndex="{true}" title="{$_('ratings.thanks')}" metaDescription="{$_('meta.description')}" />
<div class="container">
    <section class=" section-type-1 section_padding checkout">
        <div class="subline">{$_("ratings.rating")}</div>
        <h2 class="h2_nooffset">{$_("ratings.thanks")}</h2>

        <section>
            <p>
                {@html $_("ratings.rating-confirm")}
            </p>
            <a class="backbutton" href="{`/order/rating/${orderSequence}/${postalCode}`}">zurück</a>
        </section>
    </section>
</div>
